import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import ReactPlayer from 'react-player';
import urlParser from 'js-video-url-parser';

import ActionsCourse from '../../../../store/ducks/course';
import useStyles from './styles';

const Media = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { current } = useSelector(state => state.course);
  const {
    lessonInfos: { videoURL: url, videoEndMarkFinished: markFinished },
  } = props;

  const [playerProps, setPlayerProps] = useState({});

  const videoInfos = useMemo(() => {
    return urlParser.parse(url);
  }, [url]);

  const handleSetCompleted = useCallback(() => {
    const { course, lesson } = current;
    dispatch(ActionsCourse.setLessonCompleted(course, lesson, true));
  }, [dispatch, current]);

  const normalizedUrl = useMemo(() => {
    return videoInfos && videoInfos.provider === 'youtube' && videoInfos.id
      ? `https://www.youtube.com/watch?v=${videoInfos.id}`
      : url;
  }, [videoInfos, url]);

  useEffect(() => {
    setPlayerProps({
      width: '100%',
      height: '100%',
      url: normalizedUrl,
      controls: true,
      playing: true,
      muted: true,
      onEnded: () => {
        if (markFinished) {
          handleSetCompleted();
        }
      },
    });
  }, [markFinished, handleSetCompleted, normalizedUrl]);

  return (
    <Box className={classes.container} id="media">
      {playerProps?.url && (
        <ReactPlayer
          // Disable download button
          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
          className="react-player"
          // Disable right click
          onContextMenu={e => e.preventDefault()}
          // Your props
          {...playerProps}
        />
      )}
    </Box>
  );
};

export default Media;
